import { getPaddingsClassFromData, getPropSafely } from "@/utils/utils"

import { useBranch } from "@/hooks/useBranch"
import { useMemo } from "react"
import { GLOBAL_STATE } from "@/constants"
import styled from "styled-components"
import CommonImage, { formatImageCMSData } from "@/components/common/Image"
import { getLinkData } from "@/components/common/Links/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import PreserveSearchParamsLink from "@/components/common/Links/PreserveSearchParamsLink"
import useDevice from "@/hooks/useDevice"

function useFilterBannersData(data) {
	const { selectedOption } = useBranch()

	return useMemo(() => {
		const stateToFilterBy = selectedOption?.toLowerCase()

		if (!data.length) return null

		const dataFilteredByState = data.find((item) => item.state.handle.toLowerCase() === stateToFilterBy.toLowerCase())
		const useGlobalContext = dataFilteredByState?.useGlobalContext || false

		if (!dataFilteredByState || useGlobalContext) {
			return data.find((item) => item.state.handle.toLowerCase() === GLOBAL_STATE)
		}

		return dataFilteredByState
	}, [data, selectedOption])
}

const Wrapper = styled(PreserveSearchParamsLink)`
	width: 100vw;
	overflow: hidden;
`

const Image = styled(CommonImage)`
	aspect-ratio: 1;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		aspect-ratio: 1024/600;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		aspect-ratio: 1920/480;
	}
`

function formatData(data) {
	return {
		assetDesktop: formatImageCMSData(getPropSafely(data, "assetDesktop", {})),
		assetTablet: formatImageCMSData(getPropSafely(data, "assetTablet", {})),
		assetMobile: formatImageCMSData(getPropSafely(data, "assetMobile", {})),
		link: getLinkData(getPropSafely(data, "link", null)),
	}
}

export default function BannerModule({ data }) {
	const paddings = getPaddingsClassFromData(data)
	const allBanners = getPropSafely(data, "bannerModules", [])
	const contextData = useFilterBannersData(allBanners)
	const { isDesktop, isTablet } = useDevice()
	const { assetDesktop, assetTablet, assetMobile, link } = formatData(contextData)
	const asset = isDesktop ? assetDesktop : isTablet ? assetTablet : assetMobile

	return (
		<Wrapper href={link.url} className={paddings}>
			<Image src={asset.url} alt={asset.alt} />
		</Wrapper>
	)
}
